import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { ROUTES } from 'constants/routes';
// Transaction type is defined in src/types/transaction.ts

/**
 * Generates mock transaction details 
 * @param {string|number} account - The account number
 * @param {string} srcSystemKey - The source system key
 * @returns {{
 *   patientAccountInfo: {
 *     dos: string,
 *     account: string|number,
 *     statementAccount: string,
 *     lastName: string,
 *     firstName: string,
 *     dob: string,
 *     sex: string,
 *     employer: string,
 *     employerAddress: string,
 *     employerCity: string,
 *     employerState: string,
 *     employerZip: string,
 *     charge: number,
 *     pmts: number,
 *     adj: number,
 *     balance: number,
 *     pmtIns: number,
 *     pmtPat: number,
 *     collectionBal: number,
 *     pins: number,
 *     pinsPlanName: string,
 *     pinsClass: string,
 *     pinsPlanCode: string,
 *     sins: number,
 *     sinsPlanName: string,
 *     sinsClass: string,
 *     sinsPlanCode: string,
 *     tins: number,
 *     tinsPlanName: string,
 *     tinsClass: string,
 *     tinsPlanCode: string
 *   },
 *   transactions: Array<{
 *     date: string,
 *     postDt: string,
 *     tranAmt: number,
 *     planName: string,
 *     comments: string
 *   }>,
 *   billingHistory: Array<{
 *     actionDate: string,
 *     description: string,
 *     amount: number,
 *     planName: string
 *   }>,
 *   charges: Array<{
 *     no: number,
 *     date: string,
 *     cpt: string,
 *     description: string,
 *     charges: number,
 *     insPmt: number,
 *     patPmt: number,
 *     adj: number,
 *     bal: number
 *   }>,
 *   providers: Array<{
 *     invoiceNo: string|number,
 *     chargeLine: number,
 *     cpt: string,
 *     cptDesc: string,
 *     totalRVU: number,
 *     docFName: string,
 *     docLName: string,
 *     appFName: string,
 *     appLName: string,
 *     creditProviderFName: string,
 *     creditProviderLName: string
 *   }>
 * }}
 */
export const generateMockTransactionDetails = (account, srcSystemKey) => ({
  patientAccountInfo: {
    dos: '2017-06-18T00:00:00',
    account,
    statementAccount: account.toString(),
    lastName: 'LASTNAME',
    firstName: 'F',
    dob: '2015-01-03T00:00:00',
    sex: 'F',
    employer: '',
    employerAddress: ' ',
    employerCity: '',
    employerState: '',
    employerZip: '',
    charge: 335,
    pmts: 41.9,
    adj: 293.1,
    balance: 0,
    pmtIns: 41.9,
    pmtPat: 0,
    collectionBal: 0,
    pins: 6546,
    pinsPlanName: 'SOME STATE HEALTH    ',
    pinsClass: 'MCD  ',
    pinsPlanCode: 'MANCR ',
    sins: 0,
    sinsPlanName: 'SELF PAY',
    sinsClass: 'SELF PAY',
    sinsPlanCode: 'SELF PAY',
    tins: 0,
    tinsPlanName: 'SELF PAY',
    tinsClass: 'SELF PAY',
    tinsPlanCode: 'SELF PAY'
  },
  transactions: [
    {
      date: '2017-07-06T00:00:00',
      postDt: '2017-07-17T00:00:00',
      tranAmt: 41.9,
      planName: 'SOME STATE HEALTH    ',
      comments: 'PMT - 23453'
    }
  ],
  billingHistory: [
    {
      actionDate: '2017-06-29T00:00:00',
      description: 'File insurance',
      amount: 335,
      planName: 'SOME STATE HEALTH    '
    }
  ],
  charges: [
    {
      no: 1,
      date: '2017-06-18T00:00:00',
      cpt: '99283',
      description: 'EMERGENCY DEPT VISIT               ',
      charges: 335,
      insPmt: 41.9,
      patPmt: 0,
      adj: 293.1,
      bal: 0
    }
  ],
  providers: [
    {
      invoiceNo: account,
      chargeLine: 1,
      cpt: '99283',
      cptDesc: 'EMERGENCY DEPT VISIT               ',
      totalRVU: 1.84,
      docFName: 'DOCNAME',
      docLName: 'DOCLASTNAME',
      appFName: 'UNKNOWN',
      appLName: 'UNKNOWN',
      creditProviderFName: 'SOMECREDITOR',
      creditProviderLName: 'CREDTORLASTNAME'
    }
  ]
});

/**
 * Mock for transaction details endpoint
 * @type {import('stories/HrznGatewayMswBuilder').HrznGatewayMswBuilder}
 */
export const transactionDetailsMock = HrznGatewayMswBuilder.create().post(
  ROUTES.PartnerGetMyTransactionSummaryDetails,
  (req, res, ctx) => {
    const { account, srcSystemKey } = req.body;
    return res(ctx.json(generateMockTransactionDetails(account, srcSystemKey)));
  }
);
